/**
 * Calcule les gains potentiels pour le Rugby.
 * Base = 5000 pts.
 */
export const calculateRugbyPotentialGains = (selection, margin, oddsList) => {
    const BASE_POINTS = 5000;
    const PENALTY_FACTOR = 100;

    if (!oddsList || !selection) {
        return {total: 0, costPerError: 0};
    }

    const marketTypeMap = {
        'HOME': 'HOME_WINNER',
        'AWAY': 'AWAY_WINNER',
        'DRAW': 'DRAW'
    };

    const oddObj = oddsList.find(o => o.marketType === marketTypeMap[selection]);
    const odds = oddObj ? oddObj.value : 1.0;

    return {
        // Gain Max (si tout parfait)
        total: Math.round(odds * BASE_POINTS),

        // Ce que tu perds par point d'écart
        // Ex: Cote 1.50 * 100 = 150 pts perdus par erreur
        costPerError: Math.round(odds * PENALTY_FACTOR)
    };
};